// extracted by mini-css-extract-plugin
export default {"headerLogos":"Header_headerLogos__Zk7PE","behLogo":"Header_behLogo__tOoEs","clientLogo":"Header_clientLogo__tqSnB"};